<template>
  <div class="page-content-wrapper">
    <div class="section-wrapper">
      <div class="inner-container">
        <div class="section-head">
          <span>WHAT I DO</span>
          <h2>My Services</h2>
        </div>
        <div class="section-service-wrap">
          <div class="row mt-4">
            <div class="col-sm-6 col-lg-4">
              <div class="services-list b-box  p-4 wow-none fadeInUp" data-wow-none-duration="1.5s">
                <img alt="services" :src="media.web_design">
                <div class="services-list-icon">
                  <i class="lni lni-pallet"></i>
                  <span>01</span>
                </div>
                <div class="services-list-desc">
                  <h5 class="mb-0">Web Design</h5>
                  <p class=" mt-3">Designing your product plays an important role for the future of the product. A user friendly look and futuristic design is loved by all kind of users</p>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-lg-4">
              <div class="services-list b-box  p-4 wow-none fadeInUp" data-wow-none-duration="1.5s" data-wow-none-delay=".2s">
                <img alt="services" :src="media.web_development">
                <div class="services-list-icon">
                  <i class="lni lni-laptop-phone"></i>
                  <span>02</span>
                </div>
                <div class="services-list-desc">
                  <h5 class="mb-0">Web Development</h5>
                  <p class=" mt-3">I manage this part based on PHP, Laravel, Bootstrap, Vue.Js, Angular, React and all modern web services to build a smooth and upgrade solution for an Application.</p>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-lg-4">
              <div class="services-list b-box  p-4 wow-none fadeInUp" data-wow-none-duration="1.5s" data-wow-none-delay=".3s">
                <img alt="services" :src="media.service_app">
                <div class="services-list-icon">
                  <i class="lni lni-video"></i>
                  <span>03</span>
                </div>
                <div class="services-list-desc">
                  <h5 class="mb-0">Mobile Application</h5>
                  <p class=" mt-3">Our main tools are React native and Flutter to build a native Android and iOS application by one writing and both solution formula to manage clients time and financial budget.</p>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-lg-4">
              <div class="services-list b-box  p-4 wow-none fadeInUp" data-wow-none-duration="1.5s">
                <img alt="services" :src="media.cross_platform">
                <div class="services-list-icon">
                  <i class="lni lni-pallet"></i>
                  <span>04</span>
                </div>
                <div class="services-list-desc">
                  <h5 class="mb-0">Cross Platform & Hybrid Application</h5>
                  <p class=" mt-3">To build a hybrid and Cross platform application solution I prefer Ionic, Cordova, Electron.Js to build Mobile and Desktop Application</p>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-lg-4">
              <div class="services-list b-box  p-4 wow-none fadeInUp" data-wow-none-duration="1.5s" data-wow-none-delay=".2s">
                <img alt="services" :src="media.analysis">
                <div class="services-list-icon">
                  <i class="lni lni-laptop-phone"></i>
                  <span>05</span>
                </div>
                <div class="services-list-desc">
                  <h5 class="mb-0">Project Analysis and Architecture</h5>
                  <p class=" mt-3">I analysis clients idea and business logic and create a development plan with full project architecture by making Minimum Time Budget and Dev Power.</p>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-lg-4">
              <div class="services-list b-box  p-4 wow-none fadeInUp" data-wow-none-duration="1.5s" data-wow-none-delay=".3s">
                <img alt="services" :src="media.database">
                <div class="services-list-icon">
                  <i class="lni lni-video"></i>
                  <span>06</span>
                </div>
                <div class="services-list-desc">
                  <h5 class="mb-0">Database Design and Scaling</h5>
                  <p class=" mt-3">For new or existing application if there need re-decoration or scaling up the Database to make system faster and more organised or if need split u database or any NoSql database plan I manage these full requirement within short time.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section-freelance">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <div class="section-head text-center wow-none fadeInUp" data-wow-none-duration="1.5s">
                  <h2>Let's work together!</h2>
                </div>
                <div class="mt-5 wow-none text-center fadeInUp" data-wow-none-duration="1.5s" data-wow-none-delay=".2s">
                  <router-link to="contacts" class="btn ">Contact NOW!</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>

import Footer  from './../components/global/footer'
export default {
  data() {
    return {
      media: {
        web_development: core.APP_PATH + '/web_development.jpg',
        web_design: core.APP_PATH + '/web_design.jpg',
        service_app: core.APP_PATH + '/mobile-app.jpg',
        cross_platform: core.APP_PATH + '/cross_platform.jpg',
        analysis: core.APP_PATH + '/analysis.jpg',
        database: core.APP_PATH + '/database.jpg',
      },
    }
  },
  watch: {

  },
  methods: {

  },
  created() {

  },
  mounted() {

  },
  components: {
    Footer
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/services.vue